import * as React from 'react'

import { ServiceLocationCardDetail } from '@user/components/Services'

import { Panel } from '../atoms'
import { useDataNew } from './useDataNew'
import type { ENTITY_TYPES } from '@sales-center/common'
import type { ConvertLead, NewOpp, DuplicateOpp, CloneOpp } from './typings'

export type ServicesAddedNewProps = {
  entityType: ENTITY_TYPES
} & (ConvertLead | NewOpp | DuplicateOpp | CloneOpp)

export function ServicesAddedNew(props: ServicesAddedNewProps) {
  const { entityType, type, serviceLocations } = props
  const { title, localMode, locations, serviceFrequencies } = useDataNew({
    type,
    serviceLocations,
  })

  return (
    <Panel icon="service" title={title}>
      {locations.map((l) => (
        <ServiceLocationCardDetail
          disabled
          readOnly
          key={l.id}
          location={l}
          disableGrayBg
          defaultExpanded
          loading={false}
          localMode={localMode}
          entityType={entityType}
          serviceFrequencies={serviceFrequencies}
          variant="old"
        />
      ))}
    </Panel>
  )
}
